/**
 * Created by wuyanbin on 2019/7/15
 */
import { createStore } from '@souche-f2e/muji';
const initData = {
    priceGradientSteps: [
    // { min: 0, max: 1, value: 100, type: 'isMin' },
    // { min: 1, max: 3, value: 200, type: 'range' },
    // { min: 3, max: 5, value: 300, type: 'range' },
    // { min: 5, max: -1, value: 400, type: 'isMax' },
    ],
    isCanEditAble: true,
};
export default createStore({
    state: Object.assign({}, initData),
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
        RESET_STATE(state) {
            return Object.assign({}, initData);
        },
        // 在数组中倒数第二个位置插入
        ADD_ITEM(state, payload) {
            state.priceGradientSteps.splice(-1, 0, payload);
        },
        // 更新一个元素
        UPDATE_ITEM(state, payload) {
            state.priceGradientSteps.splice(payload.index, 1, payload.tempItem);
        },
        // 直接删除一个元素
        DELETE_ITEM(state, payload) {
            state.priceGradientSteps.splice(payload.index, 1);
        },
    },
    effects: {
        resetState(params) {
            this.SET_STATE(Object.assign(Object.assign({}, initData), params));
        },
        /**
         * 更新函数
         * 下一个元素的最小值是上一个元素的最大值
         * @param payload
         * @param {any} state
         */
        update(payload, { state }) {
            const { priceGradientSteps } = state;
            const tempPriceGradientSteps = [];
            priceGradientSteps.map((item, index) => {
                const tempItem = Object.assign(item, { min: index > 0 ? priceGradientSteps[index - 1].max : 0 });
                tempPriceGradientSteps.push(tempItem);
            });
            this.SET_STATE({
                priceGradientSteps: tempPriceGradientSteps,
            });
        },
        // 增加一个元素
        addItem(payload, { state }) {
            this.ADD_ITEM(payload);
            this.update({});
        },
        /**
         * 删除一个元素
         * @param payload
         * @param state
         */
        deleteItem(payload, { state }) {
            const { index } = payload;
            this.DELETE_ITEM({ index });
            this.update({});
        },
        /**
         * 修改价格区间值
         * isMix range ==> 修改元素的最大值
         * isMax ==> 修改元素的最小值
         */
        handleInputChange(payload, { state }) {
            let tempItem = {};
            if (payload.item.type === 'isMax') {
                tempItem = Object.assign(Object.assign({}, payload.item), { min: payload.value });
            }
            else {
                tempItem = Object.assign(Object.assign({}, payload.item), { max: payload.value });
            }
            this.UPDATE_ITEM({ index: payload.index, tempItem });
            this.update({});
        },
        /**
         * 修改收费金额
         * @param payload
         * @param {any} state
         */
        handleTipMoneyInputChange(payload, { state }) {
            const tempItem = Object.assign(Object.assign({}, payload.item), { value: payload.value });
            this.UPDATE_ITEM({ index: payload.index, tempItem });
        },
    },
});
